module.exports = __webpack_public_path__ + "static/media/icon-arrow-left-white.c98e25bd.svg";